import React from "react";
import { Sparkles } from "lucide-react";

const items = [
  "Buy 1 Get 1 Free on Grocery",
  "Up to 50% Off Select Items",
  "Grocery · Clothes · Gift Articles · Stationary · Bags",
  "Fresh Grocery Every Day",
  "Unbeatable Prices",
  "Everything Under One Roof",
];

export default function PromoTicker() {
  const loop = [...items, ...items];
  return (
    <section
      data-testid="promo-ticker"
      className="relative border-y border-[#9B8B3E]/20 bg-[#F5EFE0]"
    >
      <div className="py-3.5 overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap">
          {loop.map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-4 px-8 font-latin font-medium text-[#857635] text-base sm:text-lg"
            >
              <Sparkles className="w-4 h-4 text-[#9B8B3E]" />
              <span>{t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
